export default "__VITE_ASSET__BQsf_AY0__"